import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { rem } from 'polished';
import DateFormat from '../DateFormat';
import Truncate from '../Truncate';
import AvatarPerson from '../AvatarPerson';
import Image from '../Image';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';

const WrapperResultItem = styled(Link)`
  align-items: center;
  background-color: ${props => props.theme.colors.grayLightest};
  box-shadow: 1px 1px 3px ${props => props.theme.colors.grayLight};
  color: ${props => props.theme.colors.dark};
  display: flex;
  position: relative;
`;

const WrapperLinkTag = styled.a`
  align-items: center;
  background-color: ${props => props.theme.colors.grayLightest};
  box-shadow: 1px 1px 3px ${props => props.theme.colors.grayLight};
  color: ${props => props.theme.colors.dark};
  display: flex;
`;

const WrapperImage = styled.div`
  flex-basis: 100%;
  height: ${rem('80px')};
  line-height: 0;
  max-height: ${rem('80px')};
  max-width: ${rem('80px')};
  overflow: hidden;
  position: relative;
  width: ${rem('80px')};
  display: flex;
  justify-content: center;
  align-items: center;
  ${props =>
    props.avatar !== true &&
    css`
      margin-right: ${rem('15px')};
    `};

  ${props =>
    props.isImage &&
    css`
      background: ${props => props.theme.colors.grayLight};
      &:before {
        content: 'Error';
        left: 50%;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 90%;
        text-transform: uppercase;
        font-size: ${props => props.theme.fontSize.xsmall};
        font-family: ${props => props.theme.fonts.medium};
        color: ${props => props.theme.colors.gray};
        z-index: 0;
      }
    `};
`;

const ImageItem = styled(Image)`
  position: relative;
  z-index: 1;
`;

const WrapperHeader = styled.header`
  display: flex;
`;

const WrapperHeaderGroup = WrapperHeader.extend`
  align-items: center;
`;

const WrapperHeaderSection = WrapperHeader.extend`
  align-items: center;
`;

const WrapperIcon = styled.span`
  display: flex;
  margin-right: 0.6rem;
`;

const WrapperIconContent = WrapperIcon.extend`
  padding-top: 0.1rem;
  display: none;
  ${mediaqueries.greaterThan('mobile')`
    display: initial;
  `};
`;

const WrapperBody = styled.div`
  font-size: ${rem('14px')};
  margin-right: ${rem('14px')};
  :first-child {
    margin-left: ${rem('14px')};
    padding: ${rem('16px')} 0;
  }
`;

const ResultTitle = styled.h3`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('13px')};
  line-height: 1.2;
  margin: 0;
  max-height: ${rem('48px')};
  overflow: hidden;

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('14px')};
    max-height: none;
    overflow: initial;
  `};
`;

const ResultTitleDoc = ResultTitle.extend`
  word-break: break-all;

  ${mediaqueries.greaterThan('desktop')`
    word-break: initial;
  `};
`;

const ResultSubtitle = ResultTitle.withComponent('h4');

const StyledDateContainer = styled.p`
  font-size: ${rem('12px')};
  line-height: 1.8;
  ${mediaqueries.greaterThan('desktop')`
    font-size: 0.625rem;
    font-weight: bold;
  `};
`;

const StyledDateFormat = styled(DateFormat)`
  font-size: ${rem('12px')};
  line-height: 1.8;
  ${mediaqueries.greaterThan('desktop')`
    font-size: 0.625rem;
    font-weight: bold;
  `};
`;

const ResultParagraph = styled(Truncate)`
  display: none;
  font-size: ${rem('14px')};
  line-height: 1.2;
  margin: ${rem('3px')} 0 0 0;
  ${mediaqueries.greaterThan('mobile')`
    display: block;
  `};
`;

/**
 * Elements to PersonItem
 */
const PersontAvatar = styled(AvatarPerson)`
  width: ${rem('46px')};
  height: ${rem('46px')};
  font-size: ${rem('14px')};
  border-color: #191919;
`;

const PersonParagraph = ResultParagraph.extend`
  display: block;
  font-size: ${rem('12px')};
`;

const PersonSubtitle = ResultSubtitle.extend`
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('12px')};
  `};
`;

const StyledCircle = styled.div`
  width: ${rem('40px')};
  height: ${rem('40px')};
  border-radius: 50%;
  position: absolute;
  top: calc(50% - ${rem('20px')});
  left: calc(50% - ${rem('20px')});
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.05rem solid #1f1f1f;
  background-color: rgba(7, 20, 30, 0.7);
`;

const StyledIcon = styled(Icon)`
  fill: ${props => props.theme.colors.light};
  width: ${rem('16px')};
  margin-left: ${rem('2px')};
  opacity: 0.85;

  &:hover {
    fill: ${props => props.theme.colors.light};
  }
`;

export {
  WrapperResultItem,
  WrapperImage,
  WrapperHeader,
  WrapperHeaderGroup,
  WrapperHeaderSection,
  WrapperIcon,
  WrapperIconContent,
  WrapperBody,
  WrapperLinkTag,
  ResultTitle,
  ResultTitleDoc,
  StyledDateFormat,
  StyledDateContainer,
  ResultParagraph,
  PersontAvatar,
  PersonParagraph,
  ImageItem,
  PersonSubtitle,
  StyledCircle,
  StyledIcon
};
